import React, { useContext } from "react";
import { CourseContext } from "../../../Store";
import { courseDetailUrlNoWeekId } from "../../../../../service/url";
import { Icon, Tooltip } from "antd";

const Index = () => {
    const { course } = useContext(CourseContext);

    return (
        <Tooltip title="前往构建章节">
            <a href={courseDetailUrlNoWeekId(course, "/courseChapters")}>
                <Icon type="form" />
            </a>
        </Tooltip>
    );
};

export default Index;
